import React from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import api, { imageapi } from "./Api/api";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";


const Dresses = () => {
  const { slug } = useParams(); // 👈 category slug from URL

  const servicedata = useSelector((state) => state.services);
  const subservicedata = useSelector((state) => state.subservices);

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(200, 200);
  }, []);

  // by slug
  const { data: dressdata } = useQuery(
  ["dressByCategory", slug],
  () => api.get(`users/getproductsbycategoryslug/${slug}`), // ✅ make sure this API exists
  {
    select: (res) => res.data,
    enabled: !!slug,
  }
);

  // const { data: dressdata } = useQuery(
  //   ["dress", servicedata],
  //   () =>
  //     api.get(
  //       `users/getproducts/${
  //         servicedata.id
  //       }/${servicedata.hasSubservices ? subservicedata.id : 0}`
  //     ),
  //   {
  //     select: (res) => res.data,
  //   }
  // );

  const handleClick = (item) => {
    dispatch({ type: "ADD_DRESS", payload: item });
  };

  let tempDress = [];
  tempDress = dressdata?.data.map((item) => {
    if (item.image) {
      return { ...item, jsonimage: JSON.parse(item.image) };
    }
    return null;
  });
  tempDress = tempDress?.filter((item) => item != null);

  return (
    <>
    <Helmet>
      <title>{servicedata.meta_title || "South London Removals"}</title>
      <meta name="title" content={servicedata.meta_title || "South London Removals"} />
      <meta name="keywords" content={servicedata.meta_keywords || "South London Removals"} />
      <meta name="description" content={servicedata.meta_description || "South London Removals"} />
    </Helmet>
    <div>
      <div className="p-banner">
        {servicedata?.hasSubservices !== 0
          ? subservicedata?.name
          : servicedata.name}
      </div>

      <div className="product-box-inner">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="boxes">
                <div className="row d-flex justify-content-center">
                  {tempDress &&
                    tempDress.map((item, index) => (
                      <div className="col-md-3" key={index}>
                        {/* ✅ use slug here */}
                        <Link
                          style={{ textDecoration: "none", color: "inherit" }}
                          // to={`/dresses/${item.slug}`} 
                          to={`/${servicedata.slug}/${item.slug}`} 
                        >
                          <div
                            className="product-listing-inner"
                            onClick={() => handleClick(item)}
                          >
                            <div className="p-inner">
                              <img
                                src={`${imageapi}images/${item.jsonimage.picture0}`}
                                alt={item.name}
                              />
                            </div>
                            <div className="detail">
                              <h3>{item.name}</h3>
                              {item.description.length > 0 && (
                                <p>Size: {item.description}</p>
                              )}
                              <div className="prices">
                                <h5>£{item.price}</h5>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Dresses;
